(function () {
    'use strict';

    angular
        .module('app.newMentions')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider.state('home.adminNewMentions', {
                requireLogin: true,
                url: 'mention/newMentions',
                templateUrl: 'app/admin/mention/newMentions/newMentions.html?app_v=deployDate',
                data: {
                    authorizedRoles: ['Administrator', 'Achoo Analyst'],
                    navMarker: ['mention', 'newMentions']
                },
                controller: 'newMentionsCtrl'
            })
        }]);
})();